// extracted by mini-css-extract-plugin
export default {"shortcut":"ShortcutRow-module__shortcut--TPrRc"};